import React, { useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { ClearUser, updateFirm } from '../store/userSlice'
import { useDispatch } from 'react-redux'
import Image from '../components/common/Image'
import { GetGetByRandomId } from '../api/offer'

const Index = () => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const [queryParameters] = useSearchParams()
    const Firm = queryParameters.get("Firm")
    const randomId = queryParameters.get("randomId")
    const identity = [
        {title:"有優惠身份", description:"車商、產險、壽險、銀行、全鋒優惠券等", img:"/images/with_id.svg"},
        {title:"沒有優惠身份", description:"直接開始呼叫救援服務",img:"/images/without_id.svg"},
    ]
    useEffect(()=>{
    },[Firm])
    useEffect(()=>{
        if(randomId){
            GetGetByRandomId({randomId}).then(res=>{
                if(res?.result && res?.statusCode === 200){
                    dispatch(updateFirm(res.result))
                    navigate(`/identity?key=1&randomId=${randomId}`)
                }
            })
        }
    },[randomId])
  return (
    <div className='container'>
        <h1>
        歡迎使用<br/>
        全鋒一鍵救援</h1>
        <div className='select_block'>
            {
                identity.map((i,index)=>(
                <div className='block' key={i.title}
                 onClick={()=> {
                    if(index){
                        dispatch(ClearUser())
                    }
                    navigate(index===0? `/identity?key=${index+1}`:'/services')
                 }}
                >
                    <Image src={i.img}
                        // style={{width:32, height:32}}
                    />
                    <p className='font-heading'>{i.title}</p>
                    <p className='text-secondary'>{i.description}</p>
                </div>))
            }
        </div>
    </div>
  )
}

export default Index